import { render } from "./specialNeedsFilterDropdown.vue?vue&type=template&id=dc3dc8f6"
import script from "./specialNeedsFilterDropdown.vue?vue&type=script&lang=js"
export * from "./specialNeedsFilterDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script